var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDegreesandCertificates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_12129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42279 6.104C4.42279 7.46307 5.52466 8.56494 6.88373 8.56494H23.3109C22.7903 7.87729 22.4697 7.03091 22.4697 6.104C22.4697 5.17709 22.7903 4.33072 23.3109 3.64307H6.88373C5.52466 3.64307 4.42279 4.74493 4.42279 6.104Z",
    fill: "url(#paint0_linear_4402_12129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.212 30.0024C28.6651 30.0024 29.0323 29.6352 29.0323 29.1821V6.104C29.0323 4.74493 27.9304 3.64307 26.5713 3.64307C25.2123 3.64307 24.1104 4.74493 24.1104 6.104C24.1104 7.46307 25.2123 8.56494 26.5713 8.56494C27.0244 8.56494 27.3917 8.93216 27.3917 9.38525C27.3917 9.83835 27.0244 10.2056 26.5713 10.2056H7.70416V29.1821C7.70416 29.6352 8.07138 30.0024 8.52447 30.0024H17.5479C17.5479 30.0024 17.5479 22.7726 17.5479 22.5102C17.5479 20.2488 19.3881 18.4087 21.6495 18.4087C23.9109 18.4087 25.751 20.2488 25.751 22.5102C25.751 22.7726 25.751 30.0024 25.751 30.0024H28.212ZM11.8057 11.8462H24.9307C25.3842 11.8462 25.751 12.2132 25.751 12.6665C25.751 13.1198 25.3842 13.4868 24.9307 13.4868H11.8057C11.3524 13.4868 10.9854 13.1198 10.9854 12.6665C10.9854 12.2132 11.3524 11.8462 11.8057 11.8462ZM15.087 23.3306H11.8057C11.3524 23.3306 10.9854 22.9636 10.9854 22.5102C10.9854 22.0569 11.3524 21.6899 11.8057 21.6899H15.087C15.5405 21.6899 15.9073 22.0569 15.9073 22.5102C15.9073 22.9636 15.5405 23.3306 15.087 23.3306ZM15.087 20.0493H11.8057C11.3524 20.0493 10.9854 19.6823 10.9854 19.229C10.9854 18.7757 11.3524 18.4087 11.8057 18.4087H15.087C15.5405 18.4087 15.9073 18.7757 15.9073 19.229C15.9073 19.6823 15.5405 20.0493 15.087 20.0493ZM24.9307 16.7681H11.8057C11.3524 16.7681 10.9854 16.4011 10.9854 15.9478C10.9854 15.4944 11.3524 15.1274 11.8057 15.1274H24.9307C25.3842 15.1274 25.751 15.4944 25.751 15.9478C25.751 16.4011 25.3842 16.7681 24.9307 16.7681Z",
    fill: "url(#paint1_linear_4402_12129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1104 25.7705C23.4228 26.2911 22.5764 26.6118 21.6495 26.6118C20.7226 26.6118 19.8762 26.2911 19.1885 25.7705V30.8227C19.1885 31.1254 19.3552 31.4035 19.622 31.546C19.8879 31.6887 20.2124 31.6718 20.4639 31.5052L21.6495 30.7146L22.8351 31.5052C23.0895 31.6748 23.414 31.6872 23.677 31.546C23.9438 31.4035 24.1104 31.1254 24.1104 30.8227V25.7705Z",
    fill: "url(#paint2_linear_4402_12129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6495 20.0493C20.2925 20.0493 19.1885 21.1533 19.1885 22.5103C19.1885 23.8672 20.2925 24.9712 21.6495 24.9712C23.0064 24.9712 24.1104 23.8672 24.1104 22.5103C24.1104 21.1533 23.0064 20.0493 21.6495 20.0493Z",
    fill: "url(#paint3_linear_4402_12129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12129",
    x1: 13.8668,
    y1: 3.64307,
    x2: 13.8668,
    y2: 8.56494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12129",
    x1: 18.3682,
    y1: 3.64307,
    x2: 18.3682,
    y2: 30.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12129",
    x1: 21.6495,
    y1: 25.7705,
    x2: 21.6495,
    y2: 31.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12129",
    x1: 21.6495,
    y1: 20.0493,
    x2: 21.6495,
    y2: 24.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_12129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2.87695 3.41504)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreesandCertificates);
export default __webpack_public_path__ + "static/media/Degrees and Certificates.b95cbb518204624bb8f447c86cb41f40.svg";
export { ForwardRef as ReactComponent };